export const products = {
  "products.results_title": "Products found",
  "products.search_title": "Search products",
  "products.label": "products",

  "products.sort.price_asc": "Price: Low to High",
  "products.sort.price_desc": "Price: High to Low",
  "products.sort.newest": "Newest first",
  "products.sort.match_score": "Best supplier match",

  "products.no_results_title": "No products found",
  "products.no_results_subtitle": "Try different keywords or another category.",

  "products.potential_suppliers_title": "Potential suppliers",
  "products.potential_suppliers_count": "{{count}} suppliers",
  "products.more_suppliers": "+{{count}} more suppliers",
  "products.view_supplier": "View supplier",

  "products.details_title": "Product Details",
  "products.suppliers_in_category": "Suppliers in {{category}} category",
  "products.suppliers_found": "suppliers found",
  "products.no_suppliers_found": "No suppliers found for this product. You can request the admin to search for suppliers for you.",
  "products.request_supplier_search": "Request Supplier Search",
  "products.request_supplier_form_title": "Describe your needs",
  "products.request_supplier_placeholder": "Describe the type of supplier you're looking for, your specific requirements, budget, etc.",
  "products.send_request": "Send Request",
  "products.sending": "Sending...",
  "products.cancel": "Cancel",
  "products.request_sent": "Your request has been sent successfully. The admin will contact you soon.",
  "products.request_error": "An error occurred while sending your request. Please try again.",
  "products.price": "Price",

  // Match confidence badges
  "match.confidence.high": "High match",
  "match.confidence.medium": "Good match",
  "match.confidence.low": "Possible match",
  "match.confidence.unknown": "Match unknown",
  "match.score": "Match score",

  // RFQ Form
  "rfq.title": "Request a Quote",
  "rfq.subtitle": "Send your request to selected suppliers",
  "rfq.selected_suppliers": "Selected suppliers ({{count}})",
  "rfq.select_all": "Select all",
  "rfq.select_none": "Select none",
  "rfq.quantity": "Quantity needed",
  "rfq.quantity_unit": "Unit",
  "rfq.quantity_placeholder": "e.g., 100",
  "rfq.your_name": "Your name",
  "rfq.your_email": "Your email",
  "rfq.your_phone": "Phone number (optional)",
  "rfq.your_country": "Your country",
  "rfq.your_company": "Company name (optional)",
  "rfq.delivery_date": "Preferred delivery date",
  "rfq.budget_range": "Budget range",
  "rfq.budget_low": "Low budget",
  "rfq.budget_medium": "Medium budget",
  "rfq.budget_high": "High budget",
  "rfq.message": "Your message",
  "rfq.message_placeholder": "Describe your requirements, specifications, delivery preferences, etc.",
  "rfq.submit": "Send Quote Request",
  "rfq.submitting": "Sending...",
  "rfq.success_title": "Request Sent!",
  "rfq.success_message": "Your quote request has been sent to {{count}} supplier(s). You will receive responses via email.",
  "rfq.error_title": "Error",
  "rfq.error_message": "Failed to send quote request. Please try again.",
  "rfq.validation.name_required": "Please enter your name",
  "rfq.validation.email_required": "Please enter a valid email address",
  "rfq.validation.message_required": "Please enter a message",
  "rfq.validation.supplier_required": "Please select at least one supplier",

  // Verified badge
  "supplier.verified": "Verified supplier",
  "supplier.approved": "Approved supplier",
};

export default products;


